import { Button } from '@/components/ui/button';
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from '@/components/ui/dialog';
import { toast } from '@/hooks/use-toast';
import { logoutMutationFn } from '@/lib/api';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Loader } from 'lucide-react';
import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

const LogoutDialog = (props: {
    isOpen: boolean;
    setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
    const { isOpen, setIsOpen } = props;
    const queryClient = useQueryClient();

    const navigate = useNavigate();

    const { mutate, isPending } = useMutation({
        mutationFn: logoutMutationFn,
        onSuccess: () => {
            queryClient.resetQueries({
                queryKey: ['authUser'],
            });
            navigate('/');
            setIsOpen(false);
        },
        onError: (error) => {
            toast({
                title: 'Error',
                description: error.message,
                variant: 'destructive',
            });
        },
    });

    const handleLogout = useCallback(() => {
        mutate();
    }, [mutate]);
    return (
        <>
            <Dialog
                open={isOpen}
                onOpenChange={setIsOpen}>
                <DialogContent aria-describedby='Logout confirmation'>
                    <DialogHeader>
                        <DialogTitle>
                            Are you sure you want to log out?
                        </DialogTitle>
                        <DialogDescription>
                            This will end your current session and you will need
                            to log in again to access your account.
                        </DialogDescription>
                    </DialogHeader>
                    <DialogFooter>
                        <Button
                            disabled={isPending}
                            type='button'
                            onClick={handleLogout}>
                            {isPending && <Loader className='animate-spin' />}
                            Yes
                        </Button>
                    </DialogFooter>
                </DialogContent>
            </Dialog>
        </>
    );
};

export default LogoutDialog;
